import { PAGES } from './pages';

export const ACCOUNT_TABS = {
  PROFILE: 'profile',
  ADDRESS: 'address',
  CARDS: 'cards',
  ORDERS: 'orders',
  PRIMEUR_ALERT: 'primeur/search',
  WISHLIST: 'wishlist',
  NEWSLETTER: 'newsletter',
  CATALOG: 'catalog',
  DISCONNECT: 'disconnect',
  CELLAR: 'cellar',
  CUSTOMER_LOYALTY: 'premium',
  EXPRO: 'primeur-order',
  COMMUNICATION: 'communication'
} as const;

export const ACCOUNT_LINK_SEPARATOR = 'separator' as const;

export const ACCOUNT_DEFAULT_LINK = `${PAGES.ACCOUNT}/${ACCOUNT_TABS.PROFILE}` as const;

export const ACCOUNT_TRANSLATION_KEY = 'account' as const;

export const AGE = {
  OLDER_ALLOWED: 150,
  AVERAGE: 40,
  IS_18: 18,
  IS_21: 21
} as const;

export const ROLES = {
  ADMIN: 'ADMIN_MILLESIMA',
  ADMIN_EDITO: 'ADMIN_EDITO',
  REDACTOR_EDITO: 'REDACTOR_EDITO',
  HIDE_MARGINS: 'HIDE_MARGINS'
} as const;

export const CARDS_ACTIONS = {
  CONFIRM_DELETE: 'confirmDelete',
  DELETE: 'delete',
  DEFAULT: 'default'
} as const;

export const CARDS_TYPE = {
  VISA: 'VISA',
  MASTERCARD: 'MASTERCARD',
  AMERICAN_EXPRESS: 'AMERICAN EXPRESS',
  DEFAULT: 'CB'
} as const;
